module.exports = __webpack_public_path__ + "static/media/686MeldrumStNW_2018-06-18_112.f6509829.jpg";